<template>
  <div class="container-export">
    <div class="h-full batch-list" ref="batch-list-ref">
        <el-card class="box-card h-full border-none" style="width: 100%; position: relative;">
          <div class="box-header">
            <div class="uploader">
              <uploader
                  ref="ocr-uploader"
                  @on-file-added="chooseFile"
                  @on-files-added="onFilesAdded"
              />
            </div>
            <div class="flex justify-between items-end mb-5">
              <span class="whitespace-nowrap list-title">これまでの処理一覧</span>
              <div class="flex justify-end w-full ml-2 setting">
                <div class="self-center mr-7 cursor-pointer" @click="openModalSetting"><i class="el-icon-setting text-lg"></i></div>
                <el-input v-model="inputSearchBatch" @keyup.native="keyUpSearch" class="ocr-search-input w-5/6">
                  <template #append>
                  <span @click="searchBatch" class="cursor-pointer">
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.75794 14.5152C11.4902 14.5152 14.5159 11.4897 14.5159 7.7576C14.5159 4.02548 11.4902 1 7.75794 1C4.02563 1 1 4.02548 1 7.7576C1 11.4897 4.02563 14.5152 7.75794 14.5152Z" stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12.7338 12.918L16.9999 17.0013" stroke="#141414" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                  </template>
                </el-input>
              </div>
            </div>
          </div>

          <div class="box-content">
            <el-table
                ref="singleTable"
                :data="batchListFormat"
                highlight-current-row
                empty-text="データ無し"
                class="custom-el-table ocr-table"
                style="position: relative;"
                v-if="getDevice == 'desktop'"
            >
              <el-table-column property="created" label="最終更新" width="160">
                <template slot-scope="scope">
                  <div class="whitespace-nowrap">{{ $moment(scope.row.modified).format('YYYY/MM/DD HH:mm') }}</div>
                </template>
              </el-table-column>
              <el-table-column property="name" label="処理名"  class-name="custom-name-tbl-batch">
                <template slot-scope="scope">
                  <router-link :to="{ name: 'business_card_result', params: { template_id: dataActive.template_id, template_batch_id: scope.row.id }}" class="ocr-template-name ocr-text-truncate"><span>{{ scope.row.name }}</span></router-link>
                </template>
              </el-table-column>
              <el-table-column label="読取完了" width="150">
                <template slot-scope="scope">
                  <div>
                    <div class="flex justify-between items-center table-status-column">
                      <el-progress
                          :stroke-width="12"
                          :show-text="false"
                          :percentage="calcProcessed(scope.row.n_files, scope.row.n_processed)"
                          class="w-10 ocr-progress-success  ocr-progress column-progress"
                          :color="calcProcessed(scope.row.n_files, scope.row.n_processed) === 100 ? $store.state.user.setting.theme.rgb : '#7B7B7B'"
                      ></el-progress>
                      <div class="column-processed">
                        <el-button type="text" size="medium" class="p-0 text-center" v-if="!calcProcessImage(scope.row.status)">
                          <i class="el-icon-loading process-icon"></i>
                        </el-button>
                        <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-else-if="calcProcessImage(scope.row.status) && calcProcessed(scope.row.n_files, scope.row.n_processed) === 100">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                            <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                          </svg>
                        </el-button>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="person" label="チェック済" width="100">
                <template slot-scope="scope">
                  <div class="flex justify-between items-center table-status-column">
                    <div>{{ scope.row.n_confirmed }}/{{ scope.row.n_files }}</div>
                    <div class="column-processed">
                      <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-if="calcConfirmed(scope.row.n_confirmed, scope.row.n_results) >= 100">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                          <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                        </svg>
                      </el-button>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column property="person" label="" width="160px">
                <template slot-scope="scope">
                  <div class="md:flex justify-between items-center table-status-column block">
<!--                    <el-button type="text" size="medium" class="column-rerun p-0 text-center" @click="rerunOCR(scope.row)" :disabled="!calcProcessImage(scope.row.status)">-->
<!--                      <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                        <path d="M12.2389 8.11388L15.9908 5.93252M15.9908 5.93252C13.8442 4.66965 11.3153 4.26555 8.89378 4.79851C6.47228 5.33147 4.33059 6.76354 2.88359 8.81732C1.43659 10.8711 0.787304 13.4004 1.06146 15.9152C1.33562 18.4301 2.51371 20.7515 4.36757 22.4298C6.22142 24.108 8.61907 25.0237 11.096 24.9994C13.573 24.9751 15.9529 24.0126 17.7749 22.2983C19.5969 20.5839 20.7311 18.2399 20.958 15.7201C21.1848 13.2003 20.488 10.6842 19.0027 8.65921M15.9908 5.93252L14.5046 1" stroke="#141414" stroke-miterlimit="10"/>-->
<!--                      </svg>-->
<!--                    </el-button>-->
                    <el-button size="mini" class="ocr-button custom-btn-add column-export-csv" :class="calcProcessed(scope.row.n_files, scope.row.n_processed) < 100 ? 'process-disable' : ''" @click="down_csv(scope.row, false)" :disabled="calcProcessed(scope.row.n_files, scope.row.n_processed) < 100">
                      CSVをダウンロード
                    </el-button>
                   <div style="display: none">
                     <download-csv :data="itemExportCSV" :name="nameCsvDownload">
                       <el-button class="width-btn" ref="download_csv_detail" type="success" size="mini">CSV ダウンロード</el-button>
                     </download-csv>
                   </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="" width="50px" align="center" class-name="popover-table  table-menu-column">
                <template slot-scope="scope">
                  <el-popover
                      placement="bottom-end"
                      width="130"
                      trigger="click"
                      popper-class="bg-transparent shadow-none border-none ocr-dropdown"
                      @after-enter="showPopOver(scope.row.id)"
                      @hide="hidePopOver"
                  >
                    <div class="flex flex-wrap custom-popover ocr-dropdown-list">
                      <el-button type="text" @click="openUpdateBatchModal(scope.row)" class="w-full btn-rename-batch ocr-dropdown-item">処理名変更</el-button>
                      <div class="ocr-hr hr-90"></div>
                      <el-button type="text" class="w-full btn-rename-batch ocr-dropdown-item" @click="rerunOCR(scope.row)" :disabled="!calcProcessImage(scope.row.status)">
<!--                        <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                          <path d="M12.2389 8.11388L15.9908 5.93252M15.9908 5.93252C13.8442 4.66965 11.3153 4.26555 8.89378 4.79851C6.47228 5.33147 4.33059 6.76354 2.88359 8.81732C1.43659 10.8711 0.787304 13.4004 1.06146 15.9152C1.33562 18.4301 2.51371 20.7515 4.36757 22.4298C6.22142 24.108 8.61907 25.0237 11.096 24.9994C13.573 24.9751 15.9529 24.0126 17.7749 22.2983C19.5969 20.5839 20.7311 18.2399 20.958 15.7201C21.1848 13.2003 20.488 10.6842 19.0027 8.65921M15.9908 5.93252L14.5046 1" stroke="#141414" stroke-miterlimit="10"/>-->
<!--                        </svg>-->
                        再読取
                      </el-button>
                      <div class="ocr-hr hr-90"></div>
                      <el-button type="text" @click="openDeleteBatchModal(scope.row)" class="w-full btn-rename-batch ocr-dropdown-item">削除</el-button>
                    </div>
                    <el-button @click="openOptionBatch(scope.row)" type="text" slot="reference" style="margin-left: 0px; color: black; padding: 0px 0px; border: unset;">
                      <svg width="30" height="15" viewBox="0 0 3 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25865 1.76723C2.25865 2.02886 2.16694 2.25138 1.98352 2.4348C1.80152 2.6168 1.58113 2.7078 1.32234 2.7078C1.06072 2.7078 0.838195 2.6168 0.654773 2.4348C0.471352 2.25138 0.379641 2.02886 0.379641 1.76723C0.379641 1.50419 0.472773 1.28237 0.659039 1.1018C0.845305 0.919797 1.06498 0.828797 1.31808 0.828797C1.57828 0.828797 1.80009 0.921219 1.98352 1.10606C2.16694 1.29091 2.25865 1.5113 2.25865 1.76723ZM2.25865 7.76723C2.25865 8.02886 2.16694 8.25138 1.98352 8.4348C1.80152 8.6168 1.58113 8.7078 1.32234 8.7078C1.06072 8.7078 0.838195 8.6168 0.654773 8.4348C0.471352 8.25138 0.379641 8.02886 0.379641 7.76723C0.379641 7.50419 0.472773 7.28237 0.659039 7.1018C0.845305 6.9198 1.06498 6.8288 1.31808 6.8288C1.57828 6.8288 1.80009 6.92122 1.98352 7.10606C2.16694 7.29091 2.25865 7.5113 2.25865 7.76723ZM2.25865 13.7672C2.25865 14.0289 2.16694 14.2514 1.98352 14.4348C1.80152 14.6168 1.58113 14.7078 1.32234 14.7078C1.06072 14.7078 0.838195 14.6168 0.654773 14.4348C0.471352 14.2514 0.379641 14.0289 0.379641 13.7672C0.379641 13.5042 0.472773 13.2824 0.659039 13.1018C0.845305 12.9198 1.06498 12.8288 1.31808 12.8288C1.57828 12.8288 1.80009 12.9212 1.98352 13.1061C2.16694 13.2909 2.25865 13.5113 2.25865 13.7672Z" fill="#141414"/>
                      </svg>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>

            <div v-else class="table-mobile">
              <div v-for="batch in batchListFormat" :key="batch.id" @click="activeBatchMobile(batch)" :class="activeBatchMobileId == batch.id ? 'current-row-mobile': ''">
                <div class="items-center flex justify-between date-time bg-defaul-batch">
                  <div class="title">
                    <div class="whitespace-nowrap font-light">
                      <span class="md:mr-3 mr-2">{{ $moment(batch.modified).format('YYYY/MM/DD') }}</span>
                      <span>{{ $moment(batch.modified).format('HH:mm') }}</span>
                    </div>
                  </div>
                  <div class="btn download-csv items-center flex">
                    <el-button size="mini" class="ocr-button custom-btn-add column-export-csv" :class="calcProcessed(batch.n_files, batch.n_processed) < 100 ? 'process-disable' : ''" @click="down_csv(batch, true)" :disabled="calcProcessed(batch.n_files, batch.n_processed) < 100">
                      CSVをダウンロード
                    </el-button>
                    <div style="display: none">
                      <download-csv :data="itemExportCSV" :name="nameCsvDownload">
                        <el-button class="width-btn" :ref="`download_csv_detail_mobile_${batch.id}`" type="success" size="mini">CSV ダウンロード</el-button>
                      </download-csv>
                    </div>
                    <div class="popover-block text-right">
                    <el-popover
                    placement="bottom-end"
                    width="130"
                    trigger="click"
                    popper-class="bg-transparent shadow-none border-none ocr-dropdown"
                    @after-enter="showPopOver(batch.id)"
                    @hide="hidePopOver"
                    >
                      <div class="flex flex-wrap custom-popover ocr-dropdown-list">
                        <el-button type="text" @click="openUpdateBatchModal(batch)" class="w-full btn-rename-batch ocr-dropdown-item">処理名変更</el-button>
                        <div class="ocr-hr hr-90"></div>
                        <el-button type="text" class="w-full btn-rename-batch ocr-dropdown-item" @click="rerunOCR(batch)" :disabled="!calcProcessImage(batch.status)">
                          再読取
                        </el-button>
                        <div class="ocr-hr hr-90"></div>
                        <el-button type="text" @click="openDeleteBatchModal(batch)" class="w-full btn-rename-batch ocr-dropdown-item">削除</el-button>
                      </div>
                      <el-button @click="openOptionBatch(batch)" type="text" slot="reference" style="margin-left: 0px; color: black; padding: 0px 0px; border: unset;">
                        <svg width="30" height="15" viewBox="0 0 3 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.25865 1.76723C2.25865 2.02886 2.16694 2.25138 1.98352 2.4348C1.80152 2.6168 1.58113 2.7078 1.32234 2.7078C1.06072 2.7078 0.838195 2.6168 0.654773 2.4348C0.471352 2.25138 0.379641 2.02886 0.379641 1.76723C0.379641 1.50419 0.472773 1.28237 0.659039 1.1018C0.845305 0.919797 1.06498 0.828797 1.31808 0.828797C1.57828 0.828797 1.80009 0.921219 1.98352 1.10606C2.16694 1.29091 2.25865 1.5113 2.25865 1.76723ZM2.25865 7.76723C2.25865 8.02886 2.16694 8.25138 1.98352 8.4348C1.80152 8.6168 1.58113 8.7078 1.32234 8.7078C1.06072 8.7078 0.838195 8.6168 0.654773 8.4348C0.471352 8.25138 0.379641 8.02886 0.379641 7.76723C0.379641 7.50419 0.472773 7.28237 0.659039 7.1018C0.845305 6.9198 1.06498 6.8288 1.31808 6.8288C1.57828 6.8288 1.80009 6.92122 1.98352 7.10606C2.16694 7.29091 2.25865 7.5113 2.25865 7.76723ZM2.25865 13.7672C2.25865 14.0289 2.16694 14.2514 1.98352 14.4348C1.80152 14.6168 1.58113 14.7078 1.32234 14.7078C1.06072 14.7078 0.838195 14.6168 0.654773 14.4348C0.471352 14.2514 0.379641 14.0289 0.379641 13.7672C0.379641 13.5042 0.472773 13.2824 0.659039 13.1018C0.845305 12.9198 1.06498 12.8288 1.31808 12.8288C1.57828 12.8288 1.80009 12.9212 1.98352 13.1061C2.16694 13.2909 2.25865 13.5113 2.25865 13.7672Z" fill="#141414"/>
                        </svg>
                      </el-button>
                    </el-popover>
                  </div>
                  </div>
                </div>
                <hr class="hr-table-batch">
                <div class="row-batch">
                  <div class="name d-flex">
                    <div class="title">ファイル名</div>
                    <div class="content-name ocr-text-truncate">
                      <router-link :to="{ name: 'business_card_result', params: { template_id: dataActive.template_id, template_batch_id: batch.id }}" class="ocr-template-name ocr-text-truncate"><span>{{ batch.name }}</span></router-link>
                    </div>
                  </div>
                  <div class="is-reading d-flex">
                    <div class="title">読取完了</div>
                      <div class="content">
                        <div class="flex justify-between items-center table-status-column" :class="activeBatchMobileId == batch.id ? 'current-row-mobile': ''">
                        <el-progress
                            :stroke-width="8"
                            :show-text="false"
                            :percentage="calcProcessed(batch.n_files, batch.n_processed)"
                            class="w-10 ocr-progress-success  ocr-progress column-progress"
                            :color="calcProcessed(batch.n_files, batch.n_processed) === 100 ? $store.state.user.setting.theme.rgb : '#7B7B7B'"
                        ></el-progress>
                        <div class="column-processed">
                          <el-button type="text" size="medium" class="p-0 text-center" v-if="!calcProcessImage(batch.status)">
                            <i class="el-icon-loading process-icon"></i>
                          </el-button>
                          <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-else-if="calcProcessImage(batch.status) && calcProcessed(batch.n_files, batch.n_processed) === 100">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                              <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                            </svg>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="checked d-flex">
                    <div class="title">チェック済</div>
                    <div class="content">
                      <div class="flex justify-between items-center table-status-column" :class="activeBatchMobileId == batch.id ? 'current-row-mobile': ''">
                        <div style="width: 95px;">{{ batch.n_confirmed }}/{{ batch.n_files }}</div>
                        <div class="column-processed">
                          <el-button type="text" size="medium" class="p-0 text-center ocr-icon" v-if="calcConfirmed(batch.n_confirmed, batch.n_results) >= 100">
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.99998 18C7.21995 18 5.47989 17.4722 3.99985 16.4832C2.51981 15.4943 1.36626 14.0887 0.685077 12.4442C0.00388972 10.7997 -0.174327 8.99004 0.17294 7.24421C0.520206 5.49838 1.37737 3.89474 2.63604 2.63606C3.89471 1.37739 5.49835 0.520192 7.24418 0.172925C8.99001 -0.174342 10.7996 0.00393278 12.4441 0.685122C14.0887 1.36631 15.4943 2.51983 16.4832 3.99987C17.4721 5.47992 18 7.22001 18 9.00004C17.9975 11.3862 17.0485 13.6739 15.3612 15.3612C13.6739 17.0485 11.3862 17.9975 8.99998 18V18ZM8.99998 1.51667C7.51991 1.51667 6.07307 1.95553 4.84244 2.77782C3.61181 3.6001 2.65266 4.76883 2.08626 6.13624C1.51987 7.50365 1.37168 9.00832 1.66043 10.46C1.94918 11.9116 2.66189 13.245 3.70846 14.2915C4.75503 15.3381 6.08844 16.0508 7.54007 16.3396C8.9917 16.6283 10.4963 16.4801 11.8637 15.9137C13.2311 15.3473 14.3999 14.3882 15.2222 13.1575C16.0444 11.9269 16.4834 10.4801 16.4834 9.00004C16.4811 7.01602 15.6919 5.11389 14.289 3.71098C12.8861 2.30806 10.984 1.51893 8.99998 1.51667V1.51667Z" fill="#FFCC33"/>
                              <path d="M7.79793 13.1184C7.67342 13.1184 7.55014 13.0938 7.43517 13.046C7.32019 12.9983 7.21578 12.9282 7.12797 12.84L3.81819 9.53015C3.65968 9.34868 3.57604 9.11382 3.58416 8.87301C3.59228 8.6322 3.69158 8.40347 3.86195 8.2331C4.03232 8.06272 4.26105 7.9634 4.50186 7.95528C4.74267 7.94715 4.97756 8.0308 5.15903 8.18931L7.79793 10.8292L12.6224 6.00468C12.8041 5.8477 13.0385 5.76529 13.2785 5.77407C13.5184 5.78286 13.7461 5.88216 13.9159 6.05201C14.0856 6.22186 14.1847 6.44964 14.1933 6.6896C14.2019 6.92956 14.1194 7.16388 13.9623 7.34546L8.46881 12.84C8.29087 13.018 8.0496 13.1181 7.79793 13.1184Z" fill="#FFCC33"/>
                            </svg>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="pagination">
            <div :class="batchListFormat.length !== 0 ? 'block' : 'hidden'">
              <!-- PAGINATE -->
              <el-pagination
                  class="text-center ocr-pagination w-full overflow-hidden"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="paginate.currentPage"
                  :page-sizes="configPaginate.page_sizes"
                  :page-size="configPaginate.page_size"
                  :pager-count="getDevice == 'desktop' ? 7 : 5"
                  layout="prev, pager, next, sizes"
                  :total="paginate.totalItem"
              >
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>

    <el-dialog
      title="読取項目の設定"
      :visible.sync="showSettingUser"
      :width="getDevice == 'desktop' ? '45%' : '95%'"
      custom-class="modal-add"
    >
      <div class="cover-switch">
        <el-switch
            v-for="(user, index) in editSettingUser"
            v-model="user.status"
            :key="index"
            :inactive-text="user.title"
            class="custom-switch"
            active-color="#FDB92C"
            :width="50">
        </el-switch>
      </div>
      <template #footer>
        <div class="dialog-footer btn-dialog-setting text-right">
          <el-button type="text" @click="doUpdateSettingUser" class="custom-btn-add">保存</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="showAddBatchModal" title="読取バッチの作成" custom-class="modal-add ocr-dialog" :show-close="false" :width="getDevice == 'desktop' ? '30%' : '95%'" @closed="resetFormAddBatch">
      <div v-if="showLoadingAddBatchModal" id="overlay">
        <i class="el-icon-loading"></i>
      </div>
      <span slot="title">
        <p class="flex">
          <span class="w-full el-dialog__title">バッチ名をつけてください</span>
          <span v-if="template.upload_files.length" class="w-full text-right upload-file-length">{{ template.upload_files.length }}枚</span>
        </p>
      </span>
      <el-form>
        <p class="mb-4 text-red-500">{{ errorCreateBatch }}</p>
        <el-checkbox class="ocr-checkbox mb-4" v-model="template.is_shooting" label="撮影の画像である"></el-checkbox>
        <el-input placeholder="読取バッチ名" v-model="template.name" class="mb-4 ocr-input"></el-input>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button  class="ocr-button ocr-button-default" @click="showAddBatchModal = false">キャンセル</el-button>
          <el-button @click="runTemplate" class="btn-main ocr-button" :disabled="template.upload_files.length === 0 || !template.name">OK</el-button>
        </span>
      </template>
    </el-dialog>

      <el-dialog
        title="読取バッチ名の変更"
        :visible.sync="showUpdateBatchModal"
        direction="btt"
        :show-close="false"
        :width="getDevice == 'desktop' ? '30%' : '95%'" class="modal-add ocr-dialog"
        @closed="resetFormUpdateBatch">
          <el-form>
            <p class="title-modal-add">現在の名</p>
            <el-input placeholder="読取バッチ一名" :disabled="true" v-model="batchTargetEdit.name" class="mb-4 ocr-input"></el-input>
            <p class="title-modal-add">新しい名</p>
            <el-input placeholder="読取バッチ一名" v-model="batchTargetEdit.newName" class="mb-4 ocr-input"></el-input>
          </el-form>
          <template #footer>
            <span class="dialog-footer">
              <el-button class="ocr-button ocr-button-default" @click="showUpdateBatchModal = false">キャンセル</el-button>
              <el-button @click="doSaveBatchName" class="btn-main ocr-button" :disabled="!batchTargetEdit.newName">更新</el-button>
            </span>
          </template>
      </el-dialog>

      <el-dialog
        title=""
        :visible.sync="confirmDeleteBatch"
        :show-close="false"
        :width="getDevice == 'desktop' ? '30%' : '95%'">
        <span>指定している読取バッチ一を本当に削除したいですか？</span>
        <span slot="footer" class="dialog-footer">
          <el-button class="ocr-button ocr-button-default"  @click="confirmDeleteBatch = false">いいえ</el-button>
          <el-button type="primary" class="btn-main ocr-button" @click="doDeleteBatch(batchTargetDelete)">はい、削除する</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import _ from "lodash";
import { configPaginate } from "@/config/paginate";
import Uploader from '@/components/Uploader';
import {getTitleBusiness, groupItemBusiness} from "@/utils/template";
import {MULTIPLE_LINE_BUSINESS_TITLES} from "@/constants/template";

export default {
  components: {
    Uploader
  },
  data: function () {
    return {
      errorCreateBatch: '',
      typingTimer: null,
      configPaginate,
      paginate: {
        currentPage: 1,
        totalPage: 1,
        totalItem: 1,
      },
      inputSearchBatch: '',
      is_active: null,
      routeName: '',
      showAddBatchModal: false,
      showLoadingAddBatchModal: false,
      batchListFormat: [],
      template: {
        upload_files: [],
        name: "",
        is_shooting: true,
      },
      showUpdateBatchModal: false,
      batchTargetEdit: {},
      batchTargetDelete: {},
      confirmDeleteBatch: false,
      showSettingUser: false,
      editSettingUser: {},
      itemExportCSV: [],
      nameCsvDownload: null,
      activeBatchMobileId: null,
    }
  },
  computed: {
    ...mapState({
      homeDatas: state => state.home.dataHome,
      batchList: state => state.template.batches,
      batchActive: state => state.template.batch,
      dataActive: state => state.home.dataActive,
      collections: state => state.collection.collections,
      collectionActive: state => state.collection.collection,
      templateActive: state => state.template.template,
    }),
    ...mapState({
      items: state => state.template.items,
      query: state => state.template.querys
    }),
    ...mapGetters("device", ['getDevice']),
    items_data: function() {
      let data = [];
      /* For template has table */
      /* OUTPUT
        ----------------------------------------------
        |   ID   | 商品コード |   商品名   |    Date    |
        ----------------------------------------------
        |    1   |    720   |    P1     | 2021-01-02 |
        ----------------------------------------------
        |        |    721   |    P2     |            |
        ----------------------------------------------
        |        |    722   |    P2     |            |
        ----------------------------------------------
        |    2   |    800   |    P2     | 2021-11-16 |
        ----------------------------------------------
        |        |    801   |    P2     |            |
        ----------------------------------------------
       */
      // Type = 0, title in image = '', need get it from template boxes
      if(this.items && !this.templateActive.is_assignment) {
        this.items.forEach((item, index) => {
          data.push({
          })
          item.images.forEach((box, boxIndex) => {
            if (!box.title) {
              box.title = this.resultBoxes?.boxes[boxIndex]?.title;
            }
            data[index][box.title] = (box.result)
          })
        })
      }
      return data;
    },
  },
  methods: {
    ...mapActions('template', ['createTemplate', 'getTemplate', 'getResult', 'getTemplates', 'deleteTemplate', 'getTemplateResult', 'deleteCollection', 'saveTemplateName', 'getBatchList', 'getBatch', 'saveBatchName', 'deleteBatch', 'getBatchResultCsv', 'searchBatchName', 'reRunTemplateBatch', 'getUser', 'updateSettingUser']),
    ...mapActions(['loading']),
    ...mapMutations('template', ['SET_TEMPLATE', 'SET_BATCHES', 'SET_BATCH']),
    ...mapActions('detect', ['getDetectBox']),
    showPopOver(id) {
      this.is_active = id;
    },
    calcProcessImage(status) {
      return status === 1
    },
    hidePopOver() {
      this.visible = false
      this.is_active = null;
    },
    fetchBatchList: async function() {
      const data = {
        id: this.dataActive.template_id,
        page: this.paginate.currentPage,
        page_size: this.configPaginate.page_size,
      }
      let batch =  await this.getBatchList(data);
      if (batch) {
        this.paginate.currentPage = batch.current_page;
        this.paginate.totalPage = batch.num_pages;
        this.paginate.totalItem = batch.count;
        this.configPaginate.page_size = batch.page_size;
        if (batch.results) {
          this.batchListFormat = _.cloneDeep(batch.results);
        }
      }
      if (batch.results.length) {
        const hasProcessing = batch.results.some(item => item.status === 0);
        if (hasProcessing) {
          this.intervalId = this.setFetchPageInterval();
        } else {
          clearInterval(this.intervalId);
        }
      }
    },
    calcProcessed: function (n_files, n_processed) {
      let processed = 0;
      if (n_files !== 0) {
        processed = parseFloat(((n_processed / n_files) * 100).toFixed(2));
        if (processed > 100) {
          processed = 100;
        }
      }
      return processed;
    },
    onFilesAdded (files) {
      if (!files[0]) return false;
      let name = files[0].name;
      // Is file
      if (files[0].type && !this.template.name) {
        return this.template.name = name.replace(/\.[^.]*$/,'');
      }
      // Is folder
      return this.template.name = name;
    },
    calcConfirmed: function (n_confirmed, n_results) {
        let confirmed = 0;
        if (n_results != 0) {
          confirmed = parseFloat(((n_confirmed / n_results) * 100).toFixed(2));
          if (confirmed > 100) {
            return confirmed = 100;
          } else return confirmed;
        } else return confirmed = 0;
    },
    openOptionBatch: function(batch) {
      // todo
      this.is_active = batch.id;
      const data = {
        template_id: this.dataActive.template_id,
        template_batch_id: batch.id,
      }
      this.getTemplateResult(data);
    },
    openModalAddBatch: function () {
      this.showAddBatchModal = true;
    },
    openUpdateBatchModal: function(data) {
      this.batchTargetEdit = _.cloneDeep(data);
      this.showUpdateBatchModal = true;
    },
    openDeleteBatchModal: function(data) {
      this.batchTargetDelete = _.cloneDeep(data)
      this.confirmDeleteBatch = true;
    },
    openModalSetting: async function () {
      let res = await this.getUser();
      if (res) {
        this.editSettingUser = res;
      }
      this.showSettingUser = true;
    },
    selectFile: function() {
      this.$refs.selectFile.click();
    },
    chooseFile: function(file) {
      this.openModalAddBatch();
      this.template.upload_files.push(file);
      // if (!this.template.name) {
      //   const name = this.template.upload_files[0]?.name;
      //   this.template.name = name.replace(/\.[^.]*$/,'');
      // }
    },
    runTemplate: async function() {
      var sefl = this;
      sefl.showLoadingAddBatchModal = true;
      let formData = new FormData();
      formData.append("name", sefl.template.name);
      formData.append('is_scan', !sefl.template.is_shooting);
      sefl.template.upload_files.forEach(file => {
        formData.append("upload_files", file);
      })
      let response = await sefl.$store.dispatch("ocr/runTemplate", {
        formData: formData,
        id: this.dataActive.template_id,
      });
      if (response.success === true) {
        this.showAddBatchModal = true;
        sefl.batch = response.data;
        sefl.template.upload_files = [];
        sefl.template.name = '';
        await sefl.fetchBatchList();
        this.showAddBatchModal = false;
      } else {
        this.showAddBatchModal = true;
        this.errorCreateBatch = response.data.message;
      }
      sefl.showLoadingAddBatchModal = false;
    },
    doSaveBatchName: async function() {
      this.loading(true);
      let formData = new FormData();
      formData.append("name", this.batchTargetEdit.newName);
      formData.append("template_id", this.dataActive.template_id);
      formData.append("id", this.batchTargetEdit.id);
      await this.saveBatchName(formData);
      await this.fetchBatchList();
      this.showUpdateBatchModal = false;
      this.batchTargetEdit = {};
      this.loading(false);
    },
    doDeleteBatch: async function(data) {
      let res = await this.deleteBatch({
        template_batch_id: data.id,
        template_id: this.dataActive.template_id,
      });
      if(res) {
        await this.fetchBatchList();
      }
      this.confirmDeleteBatch = false;
      this.batchTargetDelete = {};
    },
    doUpdateSettingUser: async function () {
      const data = {
        settings: this.editSettingUser,
      };
      await this.updateSettingUser(data);
      await this.getUser()
      this.showSettingUser = false;
    },
    handleClose: function(done) {
      this.$confirm(`テンプレートフォルダーの追加をキャンセルしますか？`,
        {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
        })
        .then(() => {
          this.drawer.title = "";
          done();
        })
        .catch(() => {});
    },
    rerunOCR: async function (row) {
      this.loading(true);
      event.target.parentElement.parentElement.style.display = "none";
      const data = {
        id: this.dataActive.template_id,
        batchId: row.id,
      }
      let res = await this.reRunTemplateBatch(data);
      if (res) {
        this.fetchBatchList();
      }
      this.loading(false);
    },
    keyUpSearch() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.searchBatch();
      }, 500);
    },
    searchBatch: async function () {
      const data = {
        template_id: this.dataActive.template_id,
        name_search: this.inputSearchBatch,
        page: this.paginate.currentPage,
        page_size: this.configPaginate.page_size,
      }
      let res = await this.searchBatchName(data);
      this.paginate.currentPage = res.current_page;
      this.paginate.totalPage = res.num_pages;
      this.paginate.totalItem = res.count;
      this.configPaginate.page_size = res.page_size;
      this.batchListFormat = _.cloneDeep(res.results);
    },
    handleCurrentChange: async function (val) {
      this.paginate.currentPage = val;
      if (this.inputSearchBatch) {
        this.searchBatch()
      } else {
        this.fetchBatchList();
      }
    },
    handleSizeChange(val) {
      this.configPaginate.page_size = val;
      if (this.inputSearchBatch) {
        this.searchBatch()
      } else {
        this.fetchBatchList();
      }
    },
    resetFormUpdateBatch: function() {
      this.batchTargetEdit = {};
    },
    resetFormAddBatch: function() {
      this.template = {
        upload_files: [],
        name: "",
        is_shooting: true,
      }
      this.errorCreateBatch = '';
      this.$refs['ocr-uploader'].reset();
    },
    down_csv: async function(row, mobile = false) {
      this.itemExportCSV = []
      this.nameCsvDownload = row.name + '.csv'
      const data = {
        template_id: this.dataActive.template_id,
        template_batch_id: row.id
      }
      let res = await this.getTemplateResult(data);
      if (res.id) {
        this.$store.commit("template/SET_ITEMS", res.items);
        if(res.items && !this.templateActive.is_assignment) {
          // res.items.forEach((item, index) => {
          //   this.itemExportCSV.push({})
          //   item.images.forEach((box, boxIndex) => {
          //     if (!box.title) {
          //       box.title = this.resultBoxes?.boxes[boxIndex]?.title;
          //     }
          //     this.itemExportCSV[index][box.title] = (box.result)
          //   })
          // })
          let items = groupItemBusiness(res.items)
          items.forEach((item) => {
            let maxLines = 1;
            for (let i in item.group) {
              maxLines = Math.max(item.group[i].children.length, maxLines);
            }
            for (let i = 0; i < maxLines; i++) {
              let line = {...MULTIPLE_LINE_BUSINESS_TITLES}
              for (let j in item.group) {
                let box = item.group[j];
                let title = getTitleBusiness(box.parent, this.templateActive);
                if (!box.children.length) {
                  if (i === 0) line[title] = box.parent.result;
                  continue;
                }
                let boxChild = box.children[i] || {};
                line[title] = boxChild.result ? boxChild.result : '';
              }
              this.itemExportCSV.push(line)
            }
          })
        }
        if (mobile) {
          const ref_mobile = `download_csv_detail_mobile_${row.id}`;
          this.$refs[ref_mobile][0].$el.click()
        } else {
          this.$refs.download_csv_detail.$el.click()
        }
      }
    },
    // Active Batch When Click Mobile
    activeBatchMobile(batch) {
      this.activeBatchMobileId = batch.id;
    },

    // set time auto fetch template list, fetch batch list
    setFetchPageInterval(second = 10000) {
      clearInterval(this.intervalId);
      return setInterval(() => {
        if (this.inputSearchBatch) {
          return this.searchBatch();
        }
        return this.fetchBatchList();
      }, second);
    },
  },
  created: async function() {
    // Get batch list
    await this.fetchBatchList();

    await this.getUser();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
</script>

<style scoped>

.box-card {
  box-shadow: unset;
}
.batch-list/deep/.el-card__body, .template-list/deep/.el-card__body {
  height: calc(100% - 61px);
}
.batch-list/deep/.el-card__body {
  /*overflow: scroll;*/
  overflow: auto;
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.box-header .uploader {
  margin-bottom: 40px;
}
.box-content {
  min-height: 310px;
  overflow: auto;
  flex: 1;
  margin-bottom: 30px;
}
.list-title {
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.04em;
  font-weight: bold;
}
.table-status-column ::v-deep .column-progress {
  margin-right: 25px;
}

.table-status-column ::v-deep .column-processed {
  display: flex;
  align-items: center;
  margin-right: 25px;
}

::v-deep .table-menu-column .cell {
  padding-right: 0 !important;
}
.process-icon {
  color: #000000;
  font-size: 18px;
}

.ocr-template-name:hover {
  text-decoration: underline;
}

.box-content ::v-deep .el-table__body-wrapper {
  position: unset;
}
.container-export {
  margin: auto;
  width: 60%;
  height: 100%;
  padding: 40px ;
}
.custom-input-search {
  max-width: 50%;
}
.custom-btn-add {
  background: #FDB92C;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #0F172A;
  padding: 5px 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.custom-popover {
  position: absolute;
  top: 0px;
  right: -6px;
  background: #FFFFFF;
  border-radius: 6px;
  /*transform: rotate(342deg);*/
  z-index: 1;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
}
.custom-el-icon-more {
  font-size: 24px;
  transform: rotate(90deg);
}
.custom-el-table {
  cursor: pointer;
}
.status-batch {
  width: 25%;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #0F172A;
  display: inline-block;
  text-align: left;
}
.custom-icon-close {
  padding: 6px;
  background: #FFFFFF;
  border-radius: 50%;
  font-weight: bold;
  z-index: 2002;
  position: relative;
  border: 1px solid #F0F0F0;
}
.btn-rename-batch {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.05em;
  color: #0F172A;
  text-align: left;
  margin: unset;
  padding-left: 5px;
}
.btn-rename-batch:active, .btn-rename-batch:hover {
  color: #C85C54;
  background: #E0E5ED;
}
.title-modal-add {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  /*color: #000000;*/
  color: #141414;
  margin-bottom: 8px;
}
::v-deep .modal-add .el-dialog__header {
  border-bottom: 1px solid #F0F0F0;
}

::v-deep .modal-add .el-dialog__footer {
  border-top: 1px solid #F0F0F0;
}
.cover-switch {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
::v-deep .custom-name-tbl-batch > .cell > .ocr-template-name {
  font-size: 18px;
  line-height: 21px;
}
.custom-switch {
  width: 45%;
  margin-bottom: 22px;
  justify-content: space-between;
}
.custom-switch ::v-deep .el-switch__label {
  width: calc(100% - 50px);
  word-break: break-word;
}
.custom-switch:nth-last-child(2), .custom-switch:last-child {
    margin-bottom: unset;
}
.custom-switch/deep/.el-switch__label.is-active, .custom-switch/deep/.el-switch__label {
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
}
::v-deep .custom-name-tbl-batch {
  font-size: 14px;
  line-height: 21px;
}
.width-btn {
  width: 130px;
}
.upload-file-length {
  font-size: 12px;
  line-height: 17px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.pagination {
  position: -webkit-sticky;
  position: fixed;
  bottom: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  background: #fff;
  width: calc(100vw - 40% - 80px);
}
::v-deep .el-pagination__sizes {
  position: absolute;
  right: 0;
  margin: 0;
}
::v-deep .el-pagination__sizes .el-input {
  margin: 0;
}
::v-deep .el-icon-setting {
  margin-top: 7px;
  font-size: 1.5rem;
}
::v-deep .el-table__append-wrapper {
  position: absolute;
  bottom: 0;
}
@media only screen and (max-width: 1365px) {
  .container-export {
    width: 80%;
  }
  .pagination {
    width: calc(100vw - 20% - 80px);
  }
}
@media only screen and (max-width: 992px) {
  .container-export {
    width: 100%;
    padding: 24px;
  }
  .box-content {
    min-height: max-content;
    overflow: visible;
  }
  .pagination {
    width: calc(100vw - 48px);
  }
}
@media only screen and (max-width: 820px) {
  .list-title {
    font-size: 14px;
  }
}
@media only screen and (max-width: 480px) {
  ::v-deep .el-pagination__sizes {
    display: none !important;
  }
}
@media only screen and (max-width: 360px) {
  .container-export {
    padding: 8px;
  }
  .custom-btn-add {
    margin-left: 10px;
    align-items: center;
    padding: 5px 10px;
  }
}
@media only screen and (max-width: 350px) {

  .download-csv {
    margin-left: 0 !important;
    justify-content: start;
  }
}
::v-deep .el-pagination.is-background .btn-prev {
  background: unset !important;
}

::v-deep .el-pagination.is-background .btn-next {
  background: unset !important;
}
::v-deep.process-disable {
  color: #7B7B7B !important;
  background: #F4F4F4 !important;
  border: 0.5px solid #7B7B7B !important;
}
::v-deep.ocr-progress-success {
  width: 70px;
}

#overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(93, 93, 93, 0.5);
  z-index: 200000;
  cursor: pointer;
}
#overlay .el-icon-loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 300%;
}
</style>
